// Condizione professionale del collaboratore co.co.co. (stessi codici del backend, normalizzaInquadramento)
export const CONDIZIONI_PROFESSIONALI = [
  ['STUDENTE','Studente'], ['NON_OCCUPATO','Non occupato'], ['DIPENDENTE','Lavoratore dipendente'],
  ['AUTONOMO','Lavoratore autonomo / P.IVA'], ['PENSIONATO','Pensionato'], ['ALTRO','Altro (vedi note fiscali)'],
];
export const etichettaCondizione = (v) => (CONDIZIONI_PROFESSIONALI.find(([k]) => k === v) || [])[1] || null;
